// extracted by mini-css-extract-plugin
export default {"customPhoneInput":"FormPhoneInput_customPhoneInput__G7dbQ"};